export default __webpack_public_path__ + "static/media/chevron-double-left.fc28de86.svg";